import React, { useState } from 'react';
import {
    Alert,
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Modal,
    ModalDialog,
} from '@mui/joy';

// A button that asks for confirmation before running an async action, and
// shows the action's error under it. onConfirm should throw with a readable
// message on failure.
const ConfirmActionButton = ({
    label,
    title,
    message,
    confirmLabel = label,
    color = 'danger',
    size = 'sm',
    variant = 'outlined',
    startDecorator,
    onConfirm,
}) => {
    const [open, setOpen] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const run = async () => {
        setOpen(false);
        setBusy(true);
        setError(null);
        try {
            await onConfirm();
        } catch (e) {
            setError(e.message || 'The request failed.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <Box>
            <Button
                size={size}
                variant={variant}
                color={color}
                startDecorator={startDecorator}
                loading={busy}
                onClick={() => setOpen(true)}
            >
                {label}
            </Button>
            {error && (
                <Alert color="danger" variant="soft" size="sm" sx={{ mt: 1 }}>
                    {error}
                </Alert>
            )}
            <Modal open={open} onClose={() => setOpen(false)}>
                <ModalDialog role="alertdialog">
                    <DialogTitle>{title}</DialogTitle>
                    <DialogContent>{message}</DialogContent>
                    <DialogActions>
                        <Button color={color} onClick={run}>{confirmLabel}</Button>
                        <Button variant="plain" color="neutral" onClick={() => setOpen(false)}>Cancel</Button>
                    </DialogActions>
                </ModalDialog>
            </Modal>
        </Box>
    );
};

export default ConfirmActionButton;
